// @flow
import { PRODUCT_STRENGTHS } from 'Client/cms/toolkit/constants';
import { ProductStrengthsLine } from 'Components/lines/product-strengths-line/ProductStrengthsLine.jsx';
import { productStrengthsResolver } from './productStrengths.resolver';

export const productStrengthsDescriptor = {
  name: PRODUCT_STRENGTHS,
  component: ProductStrengthsLine,
  resolve: productStrengthsResolver.resolve,
};
